/**
 * 最新消息功能階段開關（對齊主 PRD Phase 1／Phase 2）
 *
 * Phase 1（上線中）：前台以學制＋年級篩選；無「分類標籤／標籤關鍵字」搜尋式篩選；後台表單不含 Phase 2 擴充欄位
 *（下架時間、SEO、學程／科目／學年度／分類標籤多選、排序輔助等）；前台可選擇不套用下架截止與排序輔助邏輯。
 *
 * Phase 2：完整篩選（學程、科目、學年度、年級、分類標籤＋搜尋式篩選）、下架／SEO、後台擴充、報表／批次匯入等（見需求單）。
 *
 * 解封 Phase 2：將下列改為 `true`，並檢查本目錄與 `ResourceSearch` 內標註 `LATEST_NEWS_PHASE2` 的註解區塊是否已一併還原。
 */
export const LATEST_NEWS_PHASE2_ENABLED = false;

/**
 * `false`：資源列與電子書相同，顯示學制／科目／學年度／年級四個下拉（Article API 篩選一併帶入）。
 * `true`：僅顯示學制＋年級兩欄（舊 Phase1 排版）。
 */
export const LATEST_NEWS_COMPACT_RESOURCE_FILTERS = false;
